import { apiClient } from '../../axios';
import { fetchClient } from '../../fetch';
import {
  MyTradingCompetitionInfo,
  TradingCompetition,
  TradingCompetitionRankings,
  TradingCompetitionRankingsParams,
} from './types';

export const fetchTradingCompetitionApi = (eventId: string) =>
  fetchClient.fetch<TradingCompetition>(`/v2/trading-competitions/${eventId}`);

export const getTradingCompetitionApi = (eventId: string) =>
  apiClient.get<TradingCompetition>(`/v2/trading-competitions/${eventId}`);

export const getMyTradingCompetitionInfoApi = (eventId: string) =>
  apiClient.get<MyTradingCompetitionInfo>(`/v2/trading-competitions/${eventId}/me`);

export const getTradingCompetitionRankingsApi = (params: TradingCompetitionRankingsParams) =>
  apiClient.get<TradingCompetitionRankings>(
    `/v2/trading-competitions/${params.competitionUrl}/${params.rankingMethod}/rankings`,
    { params },
  );
